import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  private _isLoadingApi = new BehaviorSubject<boolean>(false);
  public isLoading$ = this._loading.asObservable();
  public isLoadingApi$ = this._isLoadingApi.asObservable();

  private processes = 0;
  constructor() {}

  next(value: boolean) {
    this._loading.next(value);
  }
  show(value: boolean) {
    this._isLoadingApi.next(value);
    this._loading.next(value);
  }
}
